// Area mapping
// No two can have same stallId
//

import { HALL_KEYS_CONSTANT_DATA } from "./AreaOptionData";

const Hall7_layoutData = [
  {
    "stallId": "_7W_701",
    "area": 27,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_702",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_703",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_704",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_705",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_706",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_707",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_708",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_709",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_710",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_711",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_712",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_713",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_714",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_715",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_716",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_717",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_718",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719C",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719D",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719E",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719F",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_719H",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720D",
    "area": 27,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720E",
    "area": 27,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_720H",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721E",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721H",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_721J",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_722G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_722H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_722K",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_722L",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_722M",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723E",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723F",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723H",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723J",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_723K",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724D",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724J",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724K",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_724L",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725E",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725G",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725J",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_725K",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_14"
  },
  {
    "stallId": "_7W_726A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_726B",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_726C",
    "area": 54,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_726D",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_726E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_727A",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_727B",
    "area": 72,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_727C",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_728",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7W_729",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_730",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_731A",
    "area": 54,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_731B",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_731C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_731D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_732A",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_732B",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_732C",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_732D",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_732E",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_733A",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_733B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_733C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_733D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_733E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_733F",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_733G",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_734A",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_734G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735A",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_735G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736A",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736E",
    "area": 36,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_736H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737A",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737B",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737G",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_737H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738A",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_738H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739A",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_739H",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_740",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_741",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_742",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_743",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_744",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_745",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_746",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_747",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_748",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_749",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_750",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_751",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_752",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_753",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_754",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_755",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_13"
  },
  {
    "stallId": "_7X_756",
    "area": 27,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_757",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_758",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_759",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7X_760",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_761",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_762A",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_762B",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_762C",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_762D",
    "area": 18,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_763",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_764",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_765",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_766",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_767",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_768",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769A",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769B",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769C",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769D",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769E",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769F",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769G",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_769H",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_770",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_771",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_772",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_773",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_774",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_775",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_776",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_777",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_778",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_779",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_780",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_781",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_782",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_783",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_784",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_785",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  },
  {
    "stallId": "_7Y_786",
    "area": 9,
    "hallId": 7,
    "section": "sectionData_12"
  }
]

export const HallLayoutData = {
  // [HALL_KEYS_CONSTANT_DATA.JWCC]: Hall_Jio_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h1]: Hall1_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h2]: Hall2_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h3]: Hall3_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h4]: Hall4_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h5]: Hall5_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h6]:  Hall6_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h7]: Hall7_layoutData,
};


export const LAYOUT_VENU = "NESCO"
